<ng-template #quoteImage>
    <div class="flex w-full md:max-w-[50%] xl:max-w-[33%] flex-shrink-0">
        <img [src]="image()" [alt]="imageAlt()" class="w-full h-auto object-contain" />
    </div>
</ng-template>

<tran-ui-content-section
    [backgroundColor]="backgroundColor()"
    [backgroundImage]="backgroundImage()"
    [showOverlay]="showOverlay()"
    [overlayColor]="overlayColor()"
    [overlayOpacity]="overlayOpacity()"
    [noLeftSpacing]="noLeftSpacing()"
    [noRightSpacing]="noRightSpacing()"
>
    <div
        class="flex xl:flex-row pt-20 pb-[104px] gap-20"
        [class]="imagePosition() === 'left' ? 'flex-col-reverse' : 'flex-col'"
    >
        @if (image() && imagePosition() === 'left') {
            <ng-container *ngTemplateOutlet="quoteImage" />
        }
        <div class="flex flex-col" [class]="image() ? '' : 'lg:px-[18.25%]'">
            <div class="h-[48px]"><img src="/assets/images/quotes.svg" class="h-full w-auto object-contain" /></div>
            <div class="pt-6 pb-8 text-quote-l">{{ quote() | translate }}</div>
            <div class="text-caption-l text-soft-green">{{ author() | translate }}</div>
        </div>
        @if (image() && imagePosition() === 'right') {
            <ng-container *ngTemplateOutlet="quoteImage" />
        }
    </div>
</tran-ui-content-section>
